const invoice = {
  invoice: null,
  lines: [],
  postingAttempts: []
}

export default () => Object.assign({}, invoice, { lines: [], postingAttempts: [] })
